import React from 'react';
import styles from './DefinitionInput.module.css';
import { GlossaryConst } from '../../utils';
const DefinitionInput = /*#__PURE__*/React.memo(({
  setDefinition,
  definition,
  disabled,
  term
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "definition-input",
    className: styles.definitionLabel
  }, term ? `'${term}' ${GlossaryConst.DEFINITION}` : GlossaryConst.DEFINITION, ":"), /*#__PURE__*/React.createElement("div", {
    className: styles.inputWrapper
  }, /*#__PURE__*/React.createElement("textarea", {
    onChange: e => setDefinition(e.target.value),
    disabled: disabled,
    id: "definition-input",
    className: styles.definitionInput,
    value: definition
  })));
});
export default DefinitionInput;